import { useState } from 'react';

import { gerarCodigo } from '../api/participantes';
import type { Participante } from '../api/participantes';
import { CodigoDeAcesso, JanelaModal } from './JanelaModal';

interface NovoCodigoProps {
    participante: Participante;
    csrfToken: string;
    aoGerar: () => void;
    aoFechar: () => void;
}

/** Gerar novo código (`DP-PT-028`): confirma, gera e mostra o código novo uma vez. */
export function NovoCodigo({ participante, csrfToken, aoGerar, aoFechar }: NovoCodigoProps) {
    const [codigo, setCodigo] = useState<string | null>(null);
    const [erro, setErro] = useState<string | null>(null);
    const [processando, setProcessando] = useState(false);
    const nome = participante.nome ?? participante.matricula;

    async function gerar() {
        if (processando) return;
        setErro(null);
        setProcessando(true);
        try {
            setCodigo((await gerarCodigo({ participante, csrfToken })).codigo);
            aoGerar();
        } catch {
            setErro('Não foi possível gerar o código.');
        } finally {
            setProcessando(false);
        }
    }

    return (
        <JanelaModal titulo="Gerar novo código de acesso?" aoFechar={aoFechar} bloqueada={processando}>
            {codigo ? (
                <CodigoDeAcesso codigo={codigo} aoConcluir={aoFechar} />
            ) : (
                <>
                    <p>O código atual de {nome} deixará de valer, e o tablet conectado com ele será desconectado.</p>
                    {erro && <p className="erro-formulario" role="alert">{erro}</p>}
                    <div className="botoes-confirmacao">
                        <button type="button" className="botao-secundario" onClick={aoFechar} disabled={processando}>Cancelar</button>
                        <button type="button" className="botao-confirmar" onClick={() => void gerar()} disabled={processando}>
                            {processando ? 'Processando…' : 'Gerar código'}
                        </button>
                    </div>
                </>
            )}
        </JanelaModal>
    );
}
